import React from 'react';
import './similar.css'
import Slider from 'react-slick';
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css'
import TvSimilarVideos from './TvSimilarVideos';
import './similar.css'
import {settings2} from '../../Utils/slider';

function SimilarTv({similartvs}) {
   return (
    <>
    <h4 style={{marginLeft:"10px"}}>Similar Tv Shows</h4>
    <Slider {...settings2}>
        
        {similartvs.map((item, index)=>{
            console.log(item)
            return(
                <TvSimilarVideos {...item} keys={item.id} />
            )
        })}
    
    </Slider>
    </>
  )
}

export default SimilarTv